import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import CheckboxColumn from "@isceco/widget-library2/basic-elements/List/column/CheckboxColumn";
import {html} from '@isceco/widget-library2/external/lit'

export default class VerbrauchsstaetteColumns {

  static getColumns() {
    return [
      VerbrauchsstaetteColumns.NAME_COLUMN(),
      VerbrauchsstaetteColumns.ADRESSE_COLUMN(),
      VerbrauchsstaetteColumns.KANTON_COLUMN(),
      VerbrauchsstaetteColumns.NETZZUGANG_COLUMN(),
      VerbrauchsstaetteColumns.AUSNAHMEGRUPPE_COLUMN(),
      VerbrauchsstaetteColumns.MESSPUNKTEN_COLUMN()
    ]
  }

  static NAME_COLUMN() {
    return new StringColumn({
      key: 'name',
      text: 'verbrauchsstaette.header.name',
      sortable: true
    })
  }

  static ADRESSE_COLUMN() {
    return new StringColumn({
      key: 'adresse',
      text: 'verbrauchsstaette.header.adresse',
      sortable: true,
      weight: 1.5
    })
  }

  static KANTON_COLUMN() {
    return new StringColumn({
      key: 'kanton',
      text: 'verbrauchsstaette.header.kanton',
      weight: 0.5,
      sortable: true
    })
  }

  static NETZZUGANG_COLUMN() {
    return new CheckboxColumn({
      key: 'netzzugangsberechtigung',
      text: 'verbrauchsstaette.header.netzzugangsberechtigung',
      sortable: true,
      disabled: () => true
    })
  }

  static AUSNAHMEGRUPPE_COLUMN() {
    return new StringColumn({
      key: 'ausnahmegruppe',
      text: 'verbrauchsstaette.header.ausnahmegruppe',
      sortable: true,
      translate: true
    })
  }

  static MESSPUNKTEN_COLUMN() {
    return new GenericColumn({
      key: 'messpunkten',
      text: 'verbrauchsstaette.header.messpunkten',
      cell: {
        render: (i18n, value, row) => {
          return html`
            <ul>
              ${value.map(mp => html`<li>${mp.nummer}</li>`)}
            </ul>
          `
        }
      }
    })
  }


}
